query allExtRegions(
  $first: Int,
  $offset: Int,
  $filter: RegionMappingFilter,
  ) {
  allRegionMappings(
      first: $first,
      offset: $offset,
      filter: $filter
    ) {
    nodes {
      extId
      extRef
      feed
      mappingType
      mappingId
      createdAt
      createdBy
      intId
      mappedEntity {
        regionName
        source
        regionId
      }
    }
    totalCount
  }
}
